import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Card } from "react-bootstrap";
import logo from "../../../../src/assets/forbidden-lands/forbidden-lands-logo.webp";
import sectionDivider from "../../../../src/assets/forbidden-lands/session16_17/bitter-reach-page-banner-session-16_17.webp";
import "../../../index.css";
import { ContentContainer } from "../SessionSection";
import ModalComponent from "../modal/modal.component";
import ImageComponent from "../image/image.component";
import { useEffect } from "react";
import "./blade-runner-styles.scss";
import bladeRunnerLogo from "../../../../src/assets/blade-runner/logo-blade-runner.webp";

import synth from "../../../../src/assets/blade-runner/session04/synth-magazine.webp";

import cover from "../../../../src/assets/blade-runner/session06/blade-runner-session-06-cover.webp";
import gunfight from "../../../../src/assets/blade-runner/session06/firefight.webp";
import lilith from "../../../../src/assets/blade-runner/session05/death-of-lilith.webp";
import baselineMachine from "../../../../src/assets/blade-runner/session04/baseline-test-machine.webp";

const pageHeader = {
  color: "white",
  backgroundColor: "black",
  opacity: "0.7",
  marginTop: "20px",
  padding: "15px",
};
const cardStyle = {
  textAlign: "left",
  fontFamily: "Special Elite",
  backgroundColor: "rgba(0, 0, 0, 0.7) ",
  color: "white",
  marginBottom: "15px",
};

const BRSession06 = () => {
  const [showModal, setShowModal] = React.useState("");
  const [modalData, setModalData] = React.useState({});
  const handleClick = (img, body, isLegend, caption) => {
    setModalData({
      body: body,
      image: img,
      isLegend: isLegend,
      caption: caption,
    });
    handleOpenModal();
  };
  const handleOpenModal = () => {
    setShowModal("show");
  };
  const handleCloseModal = () => {
    setShowModal("", "");
  };

  const section1Data = [
    {
      title: "Saving Sara (Day 3, Shift 4)",
      text: (
        <div class="bladeRunnerFont bladeRunnerTitleText">
          <ImageComponent
            image={cover}
            caption="Sign of the Times"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Blade Runner Session 06: Sign of the Times. The dectectives pursue Leah and Sara Tyrell to the
                        kipple. Under the forlorn monument of a forgotten city,
                        the case will reach its climax."
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          Skinner and Marion walk away from the chaos of the Memory Lab
          aftermath. As they trudge toward their spinners a street behind the
          lab, Marion spots Leah ushering Lilith's daughter Sara into Skinner's
          spinner. In a flash, the former MVP football star sprints toward the
          rogue replicant. Skinner sees what Marion is doing and shouts out,{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            "I'm going for your spinner Marion!"{" "}
          </font>
          <br />
          <br />
          Marion leaps for the escaping vehicle, grabbing onto the landing skid
          as it rises. His broken ribs are screaming, but Marion knows pain and
          he knows he can't let it stop him. Leah scowls at him with through the
          plexiglass spinner window as she aims for the skies of LA. Marion
          shouts,
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            "Let the kid go! Now!"
          </font>
          <br />
          <br />
          Skinner is in pursuit in Marion's spinner when he receives an incoming
          call from his spinner. He hits the accept button. Leah's face fills
          the screen, Sara behind her scared and miserable. <br />
          <br />
          Leah:{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            “Thank you for keeping my daughter safe. Have a good life,
            Detectives. I know I will.”{" "}
          </font>{" "}
          Leah terminates the vidcall.
          <br />
          <br />
          As Marion clings to Leah's spinner, Skinner keeps pace below, pursuing
          through a chaos of scaffolding and unfinished towers. Marion pulls his
          PKD blaster and blasts the driver-side window with a sonic round. The
          city howls.
          <br />
          <p>
            <a href="#pageTop">Back to Top</a>
          </p>
        </div>
      ),
    },
    {
      title: "Airborn Pursuit",
      text: (
        <div class="bladeRunnerFont bladeRunnerTitleText">
          In the air, Leah is racing toward the old Hollywood sign in the hills
          of the kippled wasteland. Marion is shooting sonic rounds into the
          driver-side window and clinging to the spinner as it gains altitude.
          The rain-slick, neon lines of LAPD streets recede further and further,
          but Marion's determination is unshakable. Skinner is keeping pace, his
          spinner a place to land should Marion lose his grip.
          <br />
          <br />
          The wind tears at Marion’s coat as he fights to stay attached—each
          roll life or death. Leah pulls off a HIDE maneuver and blasts
          Skinner's ride with .50 rounds. Skinner swears and struggles to stay
          on her tail as decades-old holographic ads race across his vision like
          neon clouds.
          <br />
          <br />
          Marion tears Leah from her driver's seat onto the spinner's hood as
          the spinner continues racing through the sky. She uses her KIA to
          command the spinner with Sara to keep on its course toward the
          Hollywood sign. Skinner reads the runaway spinner's path and angle to
          realize where it's going.
          <br />
          <br />
          Marion leverages his body weight to wrest Leah; the two of them fall
          and land on Skinner's roof. Within moments both spinners land near the
          Hollywood sign next to a waiting Moonbus at the visitor center parking
          lot. Several replicants waiting for their ship to freedom gape at the
          spinners and the two blade runners tumbling onto the asphalt from the
          hood.
          <br />
          <br />
          <p>
            <a href="#pageTop">Back to Top</a>
          </p>
        </div>
      ),
    },
    {
      title: "Welcome to the Kipple",
      text: (
        <div class="bladeRunnerFont bladeRunnerTitleText">
          <ImageComponent
            image={gunfight}
            caption="Firefight"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Marion and Skinner at the Memory Lab under attack by hired soldiers while Lilith tries to protect Sara."
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          Moments after the spinners land, Skinner notices Styles in the group
          of replicants standing near the moonbus. Styles points to the sky
          behind Skinner; incoming unmarked spinner just like we've seen at the
          Memory Lab. Looks like hidden strike squad has another target even
          with Lilith dead. Fight is brutal and long with following highlights:
          <br />
          <br />
          <br />
          <ol>
            <li>
              Intense gunfire exchanges between Blade Runners and hidden strike
              squad.
            </li>
            <li>
              Stike squad downs Leah with a lucky shot. She has a fatal wound
              with death save every round.
            </li>
            <li>Styles gets struggling Sara onto the moonbus.</li>
            <li>
              Four replicants, including Styles, eventually rush the strike
              squad, providing distraction as Skinner picks up Leah to get her
              onto the moonbus.{" "}
            </li>
            <li>
              Skinner pistol whips the frightened Moonbus driver to prevent him
              leaving in panic.
            </li>
            <li>
              Marion uses the .50 HMG in spinner to rain fire on the goon squad.
              Full auto requires loss or resolve and as a replicant he has only
              one resolve left. He kisses his MVP ring, recalls the winning
              touchdown memory, and just as he thinks about how the memory isn't
              even real, he opens fire. He keeps this up for several rounds and
              pops happy pill to keep full auto going as long as he can.
            </li>
            <li>
              Last strike squad member makes it onto the moon bus but is fatally
              stabbed by Styles to end the combat encounter.
            </li>
          </ol>
          Skinner lights up a cigarette. Looking at Sara he mumbles,{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            "No amount of child psychology is going to fix what this kid's been
            through."
          </font>
          <br />
          <br />
          Marion steps out of the spinner and as the unmarked spinner leaves.
          The bodies shimmer and collapse into dust as seen before. The unmarked
          spinner, the remote activation of body decomposition to hide their
          trail . . . someone with a lot of money and means is manipulating
          events from behind a veil.
          <br />
          <br />
          <h3>Next time:</h3>
          <ul>
            <ol>
              Leah has three rounds of DEATH SAVES to make as she lay bleeding
              during the battle. Is our rogue replicant alive or not? We'll find
              out.
            </ol>
            <ol>
              What happens to Sara? She still doesn't know her mom is dead.
              Terrified from Leah, based on a template of her mom, trying to
              take her based on an implanted memory, and surviving daughter of
              the star memory designer . . . will she get the counseling she
              needs? Will she became a ward of the state?
            </ol>
            <ol>
              The moonbus was stopped, so the case is solved. How happy will
              Holden be? And Quell; will she finally have a good word for Marion
              and Skinner?
            </ol>
          </ul>
          <br />
          <p>
            <a href="#pageTop">Back to Top</a>
          </p>
        </div>
      ),
    },
  ];

  useEffect(() => {
    document.body.style.backgroundImage = `url(${require("../../../../src/assets/blade-runner/background-blade-runner-01.webp")})`;
    document.body.style.backgroundColor = "#000000";
    document.body.style.backgroundWidth = "100vw";
    document.body.backgroundHeight = "100vh";
    document.body.style.backgroundSize = "cover";
  }, []);

  return (
    <Container>
      <Row>
        <Col>
          <div
            style={{
              backgroundColor: "transparent",
              fontFamily: "Orbitron",
            }}
          >
            <div style={pageHeader}>
              <main role="main" className="inner cover text-center">
                <a name="pageTop" href="#pageTop">
                  <img
                    src={bladeRunnerLogo}
                    style={{
                      maxWidth: "400px",
                      backgroundColor: "white",
                      borderRadius: "10px",
                    }}
                    alt="Blade Runner campaign"
                  />
                </a>
              </main>

              <h1 className="cover-heading">SIGN OF THE TIMES</h1>
              <small>Blade Runner Session 06</small>

              {/* <p className="lead leadExtra">
                <BRSubNav />
              </p> */}
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <Card style={cardStyle}>
            {/* <img src={sectionDivider} alt="section divider" /> */}
            <Card.Body>
              <Card.Title
                id="cardTitle-blade-runner"
                className="cardTitle-blade-runner  "
              >
                <span
                  style={{
                    color: "white",
                    textAlign: "center",
                  }}
                >
                  The dectectives pursue Leah and Sara Tyrell to the kipple.
                  Under the forlorn monument of a forgotten city, the case will
                  reach its climax.
                </span>
                <br />
                <font
                  style={{
                    color: "#C21E56",
                    textAlign: "center",
                    fontStyle: "italic",
                  }}
                >
                  WARNING: SPOILERS for Electric Dreams case file.{" "}
                </font>
                <br />
                <small>
                  ⇐ Session 05: <a href="./blade-runner-session-05">Mindkill</a>
                  ☠ Session 07:{" "}
                  <a href="./blade-runner-session-07">The Leash</a> ⇒{" "}
                </small>
              </Card.Title>
              <div>
                <ContentContainer data={section1Data} />
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default BRSession06;
